import { render, staticRenderFns } from "./StepA.vue?vue&type=template&id=21b787bf&scoped=true"
import script from "./StepA.vue?vue&type=script&lang=js"
export * from "./StepA.vue?vue&type=script&lang=js"
import style0 from "./StepA.vue?vue&type=style&index=0&id=21b787bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b787bf",
  null
  
)

export default component.exports